export enum CustomMedia {
  'smallAndAbove' = '(min-width: 640px)',
  'mediumAndAbove' = '(min-width: 832px)',
  'largeAndAbove' = '(min-width: 960px)',
  'extraLargeAndAbove' = '(min-width: 1152px)',
  'smallAndBelow' = '(max-width: 640px)',
  'mediumAndBelow' = '(max-width: 832px)',
  'largeAndBelow' = '(max-width: 960px)',
  'extraLargeAndBelow' = '(max-width: 1152px)'
}

export const windowMatchesMediaQuery = (query: string): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  return window.matchMedia(query).matches || false
}
